import { render } from "./Photo-Upload.vue?vue&type=template&id=0db12749"
import script from "./Photo-Upload.vue?vue&type=script&lang=js"
export * from "./Photo-Upload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__